import { render, staticRenderFns } from "./RedirectIndex.vue?vue&type=template&id=189b010e&scoped=true&"
import script from "./RedirectIndex.vue?vue&type=script&lang=js&"
export * from "./RedirectIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b010e",
  null
  
)

export default component.exports